import React, { FunctionComponent, useState } from 'react';
import VideoModal from '@/components/VideoModal/VideoModal';
import { Col, Row } from '@visalex/core';

import Image from 'next/image';

import { StartOption as StartOptionProps } from '../../VisaPage';

import styles from './ListItem.module.scss';

const StartOption: FunctionComponent<StartOptionProps> = (option) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <Row>
      <Col xs={12} className={styles['list-item__image-wrapper']}>
        <Image
          className={styles['list-item__image']}
          src={option.imageUrl}
          alt={option.imageAlt}
          width={90}
          height={90}
        />
      </Col>
      <Col xs={12} className={styles['list-item__info']}>
        <div className={styles['list-item__title']}>{option.title}</div>
        {option.video ? (
          <p className={styles['list-item__description']}>
            <a className="regular-link" onClick={() => setOpen(true)}>
              {option.video.linkTitle}
            </a>
            <span>{option.video.restText}</span>
            <VideoModal isOpen={isOpen} onRequestClose={() => setOpen(false)} />
          </p>
        ) : (
          <p className={styles['list-item__description']} dangerouslySetInnerHTML={{ __html: option.description }} />
        )}
      </Col>
    </Row>
  );
};

export default StartOption;
